import React from 'react';
import { Link } from 'react-router-dom';

import SeoMeta from './SeoMeta';
const animalImg = 'https://images.unsplash.com/photo-1518717758536-85ae29035b6d?auto=format&fit=crop&w=600&q=80';

const NotFoundPage: React.FC = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-slate-50 px-4">
      <SeoMeta title="Page Not Found | IndianStockMarketGPT" description="The page you were looking for does not exist." robots="noindex, follow" />
      <img
        src={animalImg}
        alt="Cute panda looking for the page"
        className="w-64 h-64 object-cover rounded-3xl shadow-xl mb-8"
      />
      <h1 className="text-5xl font-bold font-serif text-slate-900 mb-4">404</h1>
      <p className="text-lg text-slate-500 mb-2 font-semibold">Page Not Found</p>
      <p className="text-base text-slate-400 mb-8 text-center max-w-xl">
        Oops! We couldn't find the page you were looking for.<br />
        Maybe the page moved, or you followed a broken link.
      </p>
      <Link
        to="/"
        className="bg-navy-500 hover:bg-navy-600 text-white px-8 py-3 rounded-lg font-semibold transition-all shadow-sm"
      >
        Go to Homepage
      </Link>
    </div>
  );
};

export default NotFoundPage;
